var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeature3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1189_12478)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1189_12478",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V60H60V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1189_12478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.8212 33.5038C42.8212 38.542 37.783 46.0985 30.2442 46.0985C22.7053 46.0985 17.6318 38.542 17.6318 33.5038H42.8212ZM60.4524 30.9855C60.46 23.9834 58.0389 17.1954 53.6019 11.7785C49.165 6.36164 42.9867 2.65118 36.1202 1.2796C29.2538 -0.0919763 22.1242 0.960232 15.9467 4.25687C9.76916 7.55351 4.92614 12.8905 2.24311 19.3582C-0.439909 25.8259 -0.796858 33.0239 1.23311 39.7253C3.26308 46.4267 7.55431 52.2167 13.3753 56.1083C19.1964 60 26.1869 61.7524 33.1554 61.0669C40.1238 60.3814 46.6389 57.3004 51.59 52.3491C57.2596 46.6844 60.4474 39 60.4524 30.9855ZM52.8959 30.9855C52.9023 36.2379 51.0869 41.33 47.7591 45.3937C44.4313 49.4574 39.7971 52.2412 34.6466 53.2706C29.496 54.3 24.1478 53.5112 19.5138 51.0387C14.8797 48.5662 11.2465 44.563 9.23361 39.7116C7.22069 34.8602 6.95262 29.4609 8.4751 24.4339C9.99757 19.407 13.2163 15.0637 17.5827 12.1443C21.9491 9.22498 27.1928 7.91032 32.42 8.42444C37.6472 8.93857 42.5343 11.2497 46.2483 14.9638C50.5008 19.2117 52.8919 24.9748 52.8959 30.9855ZM15.1136 25.1126V28.4655H27.7065V25.1126C27.7608 23.3872 27.1283 21.7107 25.9478 20.4512C24.7673 19.1917 23.1353 18.4519 21.4101 18.3943C19.6848 18.4519 18.0528 19.1917 16.8723 20.4512C15.6919 21.7107 15.0593 23.3872 15.1136 25.1126ZM32.7448 25.1126V28.4655H45.3395V25.1126C45.3937 23.3872 44.7612 21.7107 43.5807 20.4512C42.4003 19.1917 40.7683 18.4519 39.043 18.3943C37.3174 18.4515 35.685 19.191 34.5041 20.4506C33.3233 21.7102 32.6905 23.3869 32.7448 25.1126Z",
    fill: "#001F55"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1189_12478"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature3);
export default __webpack_public_path__ + "static/media/feature-3.27bdc93bb5d33d071bb72ec633af9d00.svg";
export { ForwardRef as ReactComponent };